import {Query} from "../../../../../app/types/Query";
import {IGridFilter} from "../../../../../app/interfaces/gridFilter/IGridFilter";
import {SelectModel} from "../../../../../app/types/SelectModel";
import {GridFilter} from "../../../../../app/types/GridFilter";
import {IOfferHeaderConfig} from "../data/interfaces/IOfferHeaderConfig";
import {IUser} from "../../../../../app/interfaces/user/IUser";
import {UserRole} from "../../../../../app/enums/UserRole";

export const buildOfferQuery = (type: string, config: IOfferHeaderConfig | null): Query => {
    const q = new Query();
    const t = getType(type);
    if (t) {
        q.addParam('t', t);
    }

    if (config) {
        let st = getSubType(config.subTab);
        if (st) {
            q.addParam('st', st);
        }

        q.addParam('role_cms', config.CM.toString())
            .addParam('role_tlm', config.TLM.toString())
            .addParam('role_fa', config.SMFA.toString())
            .addParam('role_exa', config.SMEXA.toString())
            .addParam('role_orm', config.OM.toString());

        if (config.isMapView != undefined && config.isMapView != null)
            q.addParam('isMapView', config.isMapView.toString());
    }

    return q;
}

export const buildOfferFilterQuery = (_: IGridFilter | null,
                                      predefinedFilter: SelectModel | null,
                                      filter: GridFilter | null): Query => {
    const q = new Query();

    if (predefinedFilter) {
        q.addParam('f', predefinedFilter.value);
    }

    if (filter) {
        if (filter.orderReleaseNumber !== null && filter.orderReleaseNumber !== '') {
            q.addParam('roxid', filter.orderReleaseNumber);
        }

        if (filter.customerRefNumber !== null && filter.customerRefNumber !== '') {
            q.addParam('crefn', filter.customerRefNumber);
        }

        if (filter.pickupDateFrom !== null && filter.pickupDateFrom !== '') {
            q.addParam('pkds', filter.pickupDateFrom);
        }

        if (filter.pickupDateTo !== null && filter.pickupDateTo !== '') {
            q.addParam('pkde', filter.pickupDateTo);
        }

        if (filter.deliveryDateFrom !== null && filter.deliveryDateFrom !== '') {
            q.addParam('dlds', filter.deliveryDateFrom);
        }

        if (filter.deliveryDateTo !== null && filter.deliveryDateTo !== '') {
            q.addParam('dlde', filter.deliveryDateTo);
        }

        if (filter.source.length > 0) {
            q.addParam('sc', filter.source.map(item => item.value).join('+'))
        }

        if (filter.destination.length > 0) {
            q.addParam('dc', filter.destination.map(item => item.value).join('+'))
        }

        if (filter.supplier.length > 0) {
            q.addParam('cls', filter.supplier.map(item => item.value).join('+'));
        }

        if (filter.serviceProvider.length > 0) {
            q.addParam('sps', filter.serviceProvider.map(item => item.value).join('+'));
        }

        if (filter.equipment.length > 0) {
            q.addParam('eq', filter.equipment.map(item => item.value).join('+'));
        }

        if (filter.status.length > 0) {
            q.addParam('offertype', filter.status.map(item => item).join('+'));
        }

        if (filter.tags.length > 0) {
            q.addParam('tags', filter.tags.map(item => item.value).join('+'));
        }

        if (filter.jobOrderRelease !== null && filter.jobOrderRelease !== '') {
            q.addParam('jobor', filter.jobOrderRelease);
        }
    }

    return q;
}

const getType = (t: string): string | null => {
    switch (t) {
        case 'all':
            return '1';
        case 'exchange':
            return '5';
        case 'new':
            return '2';
        case 'sent':
            return '3';
        case 'bet':
            return '4';
        case 'offer':
            return '1';
    }

    return null;
}

const getSubType = (t: string): string | null => {
    switch (t) {
        case 'offer-my-offers-tab':
            return '1';
        // case 'offer-common-tab':
        //     return '2';
        case 'offer-all-tab':
            return '3';
        case 'offer-admin-tab':
            return '10';
    }

    return null;
};

export const buildOfferGridLabel = (type?: string, user?: IUser): string => {
    switch (type) {
        case 'offer':
            return 'sidebar.offer.offer';
        case 'bet':
            if (user && user.role === UserRole.ServiceProvider && user.serviceProvider && !user.serviceProvider.hideOffers) {
                return 'sidebar.offer.my-bet'
            }
            return 'sidebar.offer.bet';
        case 'all':
            return 'sidebar.offer.all';
        case 'exchange':
            return 'sidebar.offer.exchange';
        case 'new':
            return 'sidebar.offer.new';
        case 'sent':
            return 'sidebar.offer.sent';
    }

    return 'sidebar.offer.title';
};
